(function () {
  //const productId = window.essentialAnnouncementMeta?.productData?.id;
  let productId = window.essentialAnnouncementMeta?.productData?.id;
    //console.log("productId:" + productId);

  // fallback：从 URL 中提取
  if (!productId) {
    const urlMatch = window.location.pathname.match(/\/products\/(\d+)/);
    //console.log("从网址中获取商品ID");
    productId = urlMatch ? urlMatch[1] : null;
  }

  // ✅ 校验是否为纯数字
  if (!productId || isNaN(Number(productId))) {
    //console.warn(`[⛔️ 停止执行] 未找到合法的数字型 productId：${productId}`);
    return;
  }

  // ✅ 如果没有 productId，执行原始清理逻辑
  if (!productId) {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('customily-')) {
        try {
          const data = JSON.parse(localStorage.getItem(key));
          if (data && data.variantId === null) {
            localStorage.removeItem(key);
            //console.warn(`[🧹 清除无效 customization] ${key} 中 variantId=null`);
          }
        } catch (e) {
          //console.warn(`[⚠️ JSON 解析失败] localStorage.${key}`, e);
        }
      }
    }
    return;
  }

  // ✅ 有 productId 的场景
  const storageKey = `customily-${productId}`;
  const item = localStorage.getItem(storageKey);

  const url = new URL(window.location.href);
  const currentVariant = url.searchParams.get('variant');

  let handled = false;

  if (item) {
    try {
      const data = JSON.parse(item);

      // ✅ 跳转到本地存储中的合法 variantId
      if (data && typeof data.variantId === 'number' && !isNaN(data.variantId)) {
        if (String(currentVariant) !== String(data.variantId)) {
          url.searchParams.set('variant', data.variantId);
          // console.warn(`[🧠 Customily Pre-Jump] 提前跳转至 variant=${data.variantId}`);
          window.location.replace(url.toString());
          handled = true;
        }
      }

      // ❌ 清理 variantId 为 null 的 key
      if (data && data.variantId === null) {
        localStorage.removeItem(storageKey);
        // console.warn(`[🧹 清除无效 customization] ${storageKey} 中 variantId=null`);
      }
    } catch (e) {
      // console.warn(`[⚠️ JSON 解析失败] localStorage.${storageKey}`, e);
    }
  }

  // ✅ 兜底逻辑：如果当前是 variant=null，且未跳转，删除参数
  if (!handled && currentVariant === 'null') {
    url.searchParams.delete('variant');
    const cleanUrl = url.pathname + url.search + url.hash;
    // console.warn(`[🛡️ Fallback] 当前 variant=null 且未匹配，跳转到无参数链接`);
    window.location.replace(cleanUrl);
  }
})();